import OneSignal from 'react-onesignal'
import { useNavigate } from 'react-router-dom'
import { ONESIGNAL_APP_ID } from 'shared/constants'
import allRoutes from 'shared/lib/allRoutes'

function useOneSignal() {
  const navigate = useNavigate()
  function askPermission() {
    return new Promise((resolve, reject) => {
      if ('Notification' in window) {
        Notification?.requestPermission()?.then(async (permission) => {
          resolve(permission)
        })
      } else {
        reject(new Error('Browser not support notification'))
      }
    })
  }

  function initOneSignal() {
    return new Promise((resolve, reject) => {
      if (window?.OneSignal?.initialized) {
        OneSignal.User.PushSubscription.optIn().then(() => {
          addEventListener()
          resolve(OneSignal.User.PushSubscription.id)
        })
      } else {
        askPermission().then(async (permission) => {
          if (permission === 'granted') {
            await OneSignal.init({
              appId: ONESIGNAL_APP_ID,
              allowLocalhostAsSecureOrigin: true,
              autoResubscribe: true,
              autoRegister: true,
              notificationClickHandlerMatch: 'origin',
              notificationClickHandlerAction: 'focus'
              // notifyButton: {
              //   enable: true
              // }
            })
            await OneSignal.User.PushSubscription.optIn()
            addEventListener()
            resolve(OneSignal.User.PushSubscription.id)
          } else {
            reject(new Error(permission))
          }
        })
      }
    })
  }

  function unSubscribe() {
    if (OneSignal.User.PushSubscription.token) return OneSignal.User.PushSubscription.optOut()
    else return Promise.resolve('No token found')
  }

  const checkRedirection = {
    asdp: allRoutes.editStackUp,
    amdp: allRoutes.materialManagements,
    aulp: allRoutes.verificationRequest
  }

  function redirection(redirectTo, iEntityId) {
    if (redirectTo === 'asdp') {
      navigate(allRoutes.editStackUp(iEntityId))
    } else {
      navigate(checkRedirection[redirectTo])
    }
  }

  function addEventListener() {
    console.log(OneSignal.User.PushSubscription.id)
    localStorage.setItem('sPushToken', OneSignal.User.PushSubscription.id)
    OneSignal.Notifications.addEventListener('click', ({ notification }) => {
      console.log(notification)
      redirection(notification.additionalData?.eRedirectTo, notification.additionalData?.iEntityId)
    })
  }

  return { initOneSignal, unSubscribe }
}
export default useOneSignal
